/* TODO: t() */
import React, { ComponentProps } from 'react';
import { StyleSheet } from 'react-native';

import createTextComponent from '../../support/rn-web/createTextComponent';

type NativeProps = ComponentProps<typeof TextNative>;

// This is basically a duplicate of ./Label.tsx
const Label = createTextComponent({
  tagName: 'label',
  additionalProps: {
    title: true,
    htmlFor: true,
  },
});

const TextNative = createTextComponent({
  tagName: 'div',
  additionalProps: {
    title: true,
  },
});

type Props = Omit<NativeProps, 'ref' | 'accessibilityRole'> & {
  type?: 'regular' | 'heading' | 'label' | 'title';
  accessibilityRole?: 'label';
  htmlFor?: string;
  title?: string;
  children?: React.ReactNode;
  id?: string;
};

export default function Text({
  id,
  type = 'regular',
  accessibilityRole,
  htmlFor,
  style,
  ...otherProps
}: Props) {
  return accessibilityRole === 'label' ? (
    <Label
      {...otherProps}
      nativeID={id}
      style={[styles[type], style]}
      htmlFor={htmlFor}
    />
  ) : (
    <TextNative {...otherProps} nativeID={id} style={[styles[type], style]} />
  );
}

const styles = StyleSheet.create({
  regular: {
    fontSize: 16,
  },
  heading: {
    fontSize: 20,
  },
  label: {
    fontSize: 14,
  },
  title: {
    fontWeight: '300',
    fontSize: 32,
  },
});
